import { Component } from 'preact';
import HCaptcha from '@hcaptcha/react-hcaptcha';

import { HCAPTCHA_SITE_KEY } from '../../../parameters';

class Captcha extends Component {
	handleVerify = (token) => {
		this.props.onVerify && this.props.onVerify(token);
	}

	handleError = (error) => {
		this.props.onError && this.props.onError(error);
	}

	handleExpire = () => {
		this.props.onExpire && this.props.onExpire();
	}

	render() {
		return (
			<HCaptcha
				sitekey={HCAPTCHA_SITE_KEY}
				size={'normal'} // normal, compact, invisible
				theme={'light'} // light, dark
				onVerify={this.handleVerify}
				onError={this.handleError}
				onExpire={this.handleExpire}/>
		);
	}
}

export default Captcha;



// WEBPACK FOOTER //
// ./components/blocks/raffleForm/captcha.js